"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_SILENT_RENEW_REDIRECT_URI = exports.oAuthStates = exports.AUTH_STATE_KEY_NAME = exports.SESSION_KEY = void 0;
var SESSION_KEY = 'accessToken';
exports.SESSION_KEY = SESSION_KEY;
var AUTH_STATE_KEY_NAME = 'auth';
exports.AUTH_STATE_KEY_NAME = AUTH_STATE_KEY_NAME;
var oAuthStates = {
  LOADING: 'loading',
  LOGGING_IN: 'logging in',
  LOGGING_OUT: 'logging out',
  VALID: 'valid',
  INVALID: 'invalid'
};
exports.oAuthStates = oAuthStates;
var DEFAULT_SILENT_RENEW_REDIRECT_URI = "http://".concat(location.host, "/redirect.html");
exports.DEFAULT_SILENT_RENEW_REDIRECT_URI = DEFAULT_SILENT_RENEW_REDIRECT_URI;
//# sourceMappingURL=constants.js.map